import { render, staticRenderFns } from "./rule-form-tab2-condition.vue?vue&type=template&id=64cda0d8&scoped=true&"
import script from "./rule-form-tab2-condition.vue?vue&type=script&lang=ts&"
export * from "./rule-form-tab2-condition.vue?vue&type=script&lang=ts&"
import style0 from "./rule-form-tab2-condition.vue?vue&type=style&index=0&id=64cda0d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cda0d8",
  null
  
)

export default component.exports